import { theme } from "@chakra-ui/react";

const fontWeights = {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
};

export default {
    fontWeights: {
        ...theme.fontWeights,
        ...fontWeights
    },
};
